const teamData = [
  {
    name: "Krishnakumar I",
    role: "CEO, Ettiksoft India",
    image: require("../../assets/images/profile/krishnakumar.png"),
    bio: {
      headline: "Leveraging over 20 years of experience in the automotive industry across engineering and management roles",
      points: [
        "Demonstrated leadership in global strategic projects and multi-site team management (India & Germany)",
        "In-depth technical expertise in CAN stacks, motor control, low-level drivers, and functional safety (ISO 26262)",
        "Bringing automotive-grade embedded systems reliability into smart building and cross-industry applications"
      ]
    }
  
  },
  {
    name: "Chidambaram",
    role: "CEO, Ettiksoft Vietnam",
    image: require("../../assets/images/profile/chidambaram.png"),
    bio: {
      headline:  "Over 20 years of embedded systems experience in safety-critical domains",
      points: [
        "Full product lifecycle development with strong quality focus",
        "Cross-cultural experience in China and Germany",
        "Expert in functional safety (ISO 26262) and cybersecurity"
      ]
    }
 
  },
  {
    name: "Sadananthan T",
    role: "CEO , Ettikengineering",
    image: require("../../assets/images/profile/Anandh.png"),
    bio: {
      headline:  "Over 20 years of experience at the intersection of engineering, marketing, and strategic sales",
      points: [
        "Proven track record in driving business growth through technical sales, project leadership, and key account management",
       "Cross-functional expertise spanning engineering, commercial operations, and international business development",
        "Trusted partner with strong interpersonal and negotiation skills, fostering long-term customer and stakeholder relationships"
      ]
    }
 
  },
  {
    name: "Carmelo Messina",
    role: "Co-CEO , Ettiksoft Switzerland",
    image: require("../../assets/images/profile/Carmelo.png"),
    bio: {
      headline:  "Driving innovation across automotive, medical, machinery, and automation industries for over 20 years",
      points: [
        "Proven leadership of interdisciplinary and intercultural teams for more than 15 years",
        "Expert in structuring and optimizing organizational processes in technical environments",
        "Inventor at heart with 15+ patents and a strong track record in product development"
      ]
    }
 
  },
  {
    name: "Arthur Bogusch",
    role: "Co-CEO , Ettiksoft Switzerland",
    image: require("../../assets/images/profile/aurthur.png"),
    bio: {
      headline:  "20+ years of expertise in procurement, supply chain management, and digital transformation",
      points: [
        "Hands-on leader in operational excellence and interim management across industrial sectors",
        "Trusted advisor known for adaptability, deep industry knowledge, and results-driven execution",
        "At Ettiksoft, driving business development and strategic sales growth through a strong industrial network"
      ]
    }
 
  },
  {
    name: "C Jyoti Swaroopa",
    role: "Strategy Manager , Ettiksoft",
    image: require("../../assets/images/profile/jothi.png"),
    bio: {
      headline:  "With 17 years of experience in Key Account Management and Client Account Management, I bring a strategic edge to business development, client engagement, and organizational growth. At Ettiksoft Technologies Pvt. Ltd., ",
      points: [
       "I lead initiatives that transform R&D innovations into commercially viable solutions—bridging the gap between technical excellence and market readiness.",
       " My focus lies in aligning business goals with client success, driving long-term partnerships, and unlocking value across strategic accounts. ",
       "Passionate about cross-functional collaboration, I work with global teams to build scalable strategies and foster sustainable growth across the enterprise."
      ]
    }
 
  },
  {
    name: "Delphine Santhosh",
    role: "Key Account Manager , Ettiksoft",
    image: require("../../assets/images/profile/delphine.png"),
    bio: {
      headline:  "Leveraging over 20 years of experience in global recruitment, client success, and strategic account management across diverse industries.",
      points: [
       "Demonstrated leadership in driving business growth, managing large-scale client portfolios, and leading cross-functional teams. ",
      "In-depth expertise in talent acquisition, client engagement, and operational excellence—bridging the gap between business strategy and execution.",
      "At Ettiksoft, bringing people-first, process-driven leadership into the tech, automotive, and enterprise consulting space to create scalable, sustainable success."
      ]
    }
 
  },
  {
    name: "Nandhakumar M",
    role: "CEO, CODEWENTS (BU Software)",
    image: require("../../assets/images/profile/nandhan.png"),
    bio: {
      headline:  "Over 5 years of hands-on experience in software development ,product engineering and delivering industrial-grade applications",
      points: [
        "Deep expertise across the software lifecycle—from solution architecture and backend systems to cloud deployment and DevOps.",
        "Passionate about translating complex business needs into scalable digital products with a focus on reliability, performance, and clean system design.",
        "Empowering clients with future-ready solutions by combining technical depth, lean execution, and startup agility."
      ]
    }
 
  },

];

export default teamData;
